import { Grid } from "@mui/material";
import { RestrictedMakerRealm } from "features/access-management";

import { AccessGrantsCard } from "features/access-grants";
import { ApiKeysCard } from "features/public-api";
import { RateAgreementsCard } from "features/rate-agreements";
import { SolutionOverview } from "features/solution";
import {
  AdminConsoleCard,
  RestrictedTenantRealm,
  TenantPermission
} from "features/tenant";

import { WorkspacesCard } from "features/workspace";
import { getConfigValue } from "utils/config";

export default function LandingPage() {
  const appStreamEnabled = getConfigValue("APPSTREAM_ENABLED");
  return (
    <Grid container spacing={4}>
      <RestrictedMakerRealm silent>
        <Grid item xs={12}>
          <SolutionOverview />
        </Grid>
      </RestrictedMakerRealm>
      <Grid container spacing={4} padding={4}>
        <RestrictedMakerRealm silent>
          <RestrictedTenantRealm
            requiredPermissions={[TenantPermission.ReadApiKeys]}
            silent
          >
            <Grid item>
              <ApiKeysCard />
            </Grid>
          </RestrictedTenantRealm>
        </RestrictedMakerRealm>
        <RestrictedTenantRealm
          requiredPermissions={[TenantPermission.ManageAccessGrants]}
          silent
        >
          <Grid item>
            <AccessGrantsCard />
          </Grid>
        </RestrictedTenantRealm>
        {appStreamEnabled !== "false" && (
          <RestrictedMakerRealm silent>
            <RestrictedTenantRealm
              requiredPermissions={[TenantPermission.ReadWorkspaces]}
              silent
            >
              <Grid item>
                <WorkspacesCard />
              </Grid>
            </RestrictedTenantRealm>
          </RestrictedMakerRealm>
        )}
        <RestrictedTenantRealm
          requiredPermissions={[TenantPermission.ChangeTenantMemberPermissions]}
          silent
        >
          <Grid item>
            <AdminConsoleCard />
          </Grid>
        </RestrictedTenantRealm>
        <RestrictedTenantRealm
          requiredPermissions={[TenantPermission.ReadRateAgreements]}
          silent
        >
          <Grid item>
            <RateAgreementsCard />
          </Grid>
        </RestrictedTenantRealm>
      </Grid>
    </Grid>
  );
}
